import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePutApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { ProbeStock, ProbeStockForm, ProbeStockSearchForm } from 'entities/probe_stock'

type ProbeStocksResponse = PagingResponse & {
    results: ProbeStock[]
}

export function useFetchProbeStocksApi(
    searchForm?: Form<ProbeStockSearchForm>
): IndexApiSet<ProbeStocksResponse> & { execute: () => void; executeAndPageReset: () => void } {
    const apiPath = 'probe_stocks/'
    const api = useIndexApi<ProbeStocksResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: searchForm?.object.page || 1, perPage: searchForm?.object.perPage || 50 },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm?.object })
    }

    const executeAndPageReset = (): void => {
        if (api.pageSet.page == 1) {
            execute()
        } else {
            api.pageSet.setPage(1)
        }
    }

    useEffectSkipFirst(() => {
        execute()
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        executeAndPageReset()
    }, [searchForm?.object])

    return { ...api, execute: execute, executeAndPageReset: executeAndPageReset }
}

export function usePutProbeStockApi(): ApiSet<BaseResponse> & { execute: (form: Form<ProbeStockForm>) => void } {
    const apiSet = usePutApi<BaseResponse, ProbeStockForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<ProbeStockForm>) => {
        const apiPath = `probe_stocks/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutProbeStocksApi(): ApiSet<BaseResponse> & { execute: (form: Form<ProbeStockForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, ProbeStockForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<ProbeStockForm[]>) => {
        const apiPath = `probe_stocks/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
